import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgImageFactoryComponent } from './pg-image-factory/pg-image-factory.component';

@NgModule({
  declarations: [PgImageFactoryComponent],
  exports: [PgImageFactoryComponent],
  imports: [CommonModule],
})
export class GritImageModule {}
